document.addEventListener( 'DOMContentLoaded', () => {
  new Splide( '#js-shSlideshow', {
    type: 'loop',
    autoplay: true,
    interval: 5000,
    pagination: false,
    arrows: false,
    speed: 1500
  }).mount();

  // 商品紹介スライダーを動的に初期化（複数インスタンス対応）
  // breakpointsオプションを利用して768px未満のときのみ有効化
  document.querySelectorAll('.sh-product-intro__slide.splide').forEach((element) => {
    if (element.id) {
      new Splide('#' + element.id, {
        type: 'loop',
        pagination: false,
        // breakpointsで768px以上はdestroy
        breakpoints: {
          768: {
            destroy: false
          },
          767: {
            destroy: false
          },
        },
        // 初期状態で無効（768px以上ではdestroy）、768px未満で初期化
        destroy: window.innerWidth >= 768
      }).mount();
    }
  });

  new Splide('#js-shFeature1Slide', {
    pagination: false,
    // arrows: false,
    speed: 1500,
    gap: 60,
    padding: '22%',
    focus: 'center',
    clones: 3,
    breakpoints: {
      768: {
        padding: 0,
        gap: 20,
      },
    },
    // 初期状態で無効（768px以上ではdestroy）、768px未満で初期化
    destroy: window.innerWidth >= 768
  }).mount();

  // 商品紹介ビデオのサムネイル全体をクリック可能にする
  const initVideoClick = () => {
    const videoElement = document.querySelector('.sh-product-intro__video video');

    if (videoElement) {
      const handleClick = function(e) {
        // ポーズ状態の時のみ処理
        if (this.paused) {
          // クリック位置を取得
          const rect = this.getBoundingClientRect();
          const clickY = e.clientY - rect.top;
          const videoHeight = rect.height;
          const clickRatio = clickY / videoHeight;

          // 下部20%をコントロールバーエリアとして除外
          // それ以外の領域（サムネイル部分）をクリックした場合は再生
          if (clickRatio < 0.8) {
            e.preventDefault();
            e.stopPropagation();
            this.play().catch(() => {
              // 再生エラーは無視
            });
          }
        }
      };

      // ビデオ要素に直接イベントリスナーを追加（capture phaseで捕捉）
      videoElement.addEventListener('click', handleClick, true);
      return true;
    }

    return false;
  };

  // 即座に試す
  if (!initVideoClick()) {
    // 見つからない場合は少し待って再試行
    setTimeout(() => {
      if (!initVideoClick()) {
        // MutationObserverで監視
        const container = document.querySelector('.sh-product-intro__video');
        if (container) {
          const observer = new MutationObserver(() => {
            if (initVideoClick()) {
              observer.disconnect();
            }
          });
          observer.observe(container, { childList: true, subtree: true });
          setTimeout(() => observer.disconnect(), 5000);
        }
      }
    }, 1000);
  }
} );